import styled from 'styled-components';

import { media } from '~/utils';

export const StyledSide = styled.div`
  padding: 85px 35px 40px;
  width: 455px;
  background: #fff;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.01);

  ${media.mid`
    width: calc(100% - 30px);
    padding: 0 15px 40px;
    display: flex;
    flex-direction: column;
    align-items: center;
  `}
`;

export const StyledSideText = styled.p`
  margin-top: 46px;
  font-size: 16px;
  font-weight: 400;
  line-height: 26px;
  letter-spacing: 0.8;
  text-align: left;

  ${media.mid`
    width: 100%;
    max-width: 500px;
  `}
`;

export const StyledSideTitle = styled.b`
  color: #0a59a6;
  font-size: 32px;
  font-weight: 700;
  line-height: 42px;
  letter-spacing: 0px;
  text-align: left;

  ${media.mid`
    font-size: 28px;
    line-height: 35px;
  `}
`;

export const StyledSideButtons = styled.div`
  margin-top: 23px;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 12px;

  ${media.mid`
    width: calc(100vw - 30px);
    max-width: 500px;
  `}
`;

export const StyledSidePrimaryButton = styled.button`
  flex: 1;
  height: 43px;
  background-color: #0a59a6;
  box-sizing: border-box;
  border: 1px solid #0a59a6;
  color: #fff;
  font-size: 16px;
  line-height: 42px;
  letter-spacing: 0.8px;
  text-align: center;
  font-weight: 700;
  border-radius: 22px;

  &:disabled {
    background: #dedede;
    border-color: #dedede;
  }
`;

export const StyledSideSecondaryButton = styled(StyledSidePrimaryButton)`
  color: #0a59a6;
  background-color: #fff;
`;

export const StyledSideConfirmText = styled.p`
  margin-top: 38px;
  font-size: 14px;
  font-weight: 400;
  line-height: 26px;
  letter-spacing: 0.8;
  text-align: left;

  & > b {
    margin-left: 14px;
  }

  ${media.mid`
    width: calc(100vw - 30px);
    max-width: 500px;
  `}
`;
